import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    user: '',
    server:[],
  },
  mutations: {
    increment(state) {
      // 变更状态
      state.token = ''
      state.user = ''
    }
  },
  actions: {
    LogOut(context) {
      context.commit('increment')
    }
  },
  modules: {}
})
